import type { Skill } from 'bundles/browse-common/legacy/components/Domain/types/Skill';

import _t from 'i18n!nls/browse';

type domainPopularTopicsData = { [domainSlug: string]: Skill[] };

const getDomainPopularTopicsData = (): domainPopularTopicsData => {
  return {
    'arts-and-humanities': [
      {
        skillId: 'writing',
        skillName: _t('Writing'),
        skillSearchUrl: '/courses?query=writing',
      },
      {
        skillId: 'art-history',
        skillName: _t('Art History'),
        skillSearchUrl: '/courses?query=art%20history',
      },
      {
        skillId: 'video-editing',
        skillName: _t('Video Editing'),
        skillSearchUrl: '/courses?query=video%20editing',
      },
      {
        skillId: 'animation',
        skillName: _t('Animation'),
        skillSearchUrl: '/courses?query=animation',
      },
      {
        skillId: 'photoshop',
        skillName: _t('Photoshop'),
        skillSearchUrl: '/courses?query=photoshop',
      },
      {
        skillId: 'journalism',
        skillName: _t('Journalism'),
        skillSearchUrl: '/courses?query=journalism',
      },
      {
        skillId: 'art',
        skillName: _t('Art'),
        skillSearchUrl: '/courses?query=art',
      },
      {
        skillId: 'photography',
        skillName: _t('Photography'),
        skillSearchUrl: '/courses?query=photography',
      },
      {
        skillId: 'film',
        skillName: _t('Film'),
        skillSearchUrl: '/courses?query=film',
      },
      {
        skillId: 'music-theory',
        skillName: _t('Music Theory'),
        skillSearchUrl: '/courses?query=music%20theory',
      },
    ],
    business: [
      {
        skillId: 'project-management',
        skillName: _t('Project Management'),
        skillSearchUrl: '/courses?query=project%20management',
      },
      {
        skillId: 'product-management',
        skillName: _t('Product Management'),
        skillSearchUrl: '/courses?query=product%20management',
      },
      {
        skillId: 'hr',
        skillName: _t('Human Resources'),
        skillSearchUrl: '/courses?query=hr',
      },
      {
        skillId: 'communication-skills',
        skillName: _t('Communication Skills'),
        skillSearchUrl: '/courses?query=communication%20skills',
      },
      {
        skillId: 'business-analysis',
        skillName: _t('Business Analysis'),
        skillSearchUrl: '/courses?query=business%20analysis',
      },
      {
        skillId: 'supply-chain',
        skillName: _t('Supply Chain'),
        skillSearchUrl: '/courses?query=supply%20chain',
      },
      {
        skillId: 'sales',
        skillName: _t('Sales'),
        skillSearchUrl: '/courses?query=sales',
      },
      {
        skillId: 'e-commerce',
        skillName: _t('E-Commerce'),
        skillSearchUrl: '/courses?query=e-commerce',
      },
      {
        skillId: 'risk-management',
        skillName: _t('Risk Management'),
        skillSearchUrl: '/courses?query=risk%20management',
      },
      {
        skillId: 'business-development',
        skillName: _t('Business Development'),
        skillSearchUrl: '/courses?query=business%20development',
      },
    ],
    'computer-science': [
      {
        skillId: 'blockchain',
        skillName: _t('Blockchain'),
        skillSearchUrl: '/courses?query=blockchain',
      },
      {
        skillId: 'linux',
        skillName: _t('Linux'),
        skillSearchUrl: '/courses?query=linux',
      },
      {
        skillId: 'agile',
        skillName: _t('Agile'),
        skillSearchUrl: '/courses?query=agile',
      },
      {
        skillId: 'scala',
        skillName: _t('Scala'),
        skillSearchUrl: '/courses?query=scala',
      },
      {
        skillId: 'coding',
        skillName: _t('Coding'),
        skillSearchUrl: '/courses?query=coding',
      },
      {
        skillId: 'react-js',
        skillName: _t('ReactJS'),
        skillSearchUrl: '/courses?query=react%20js',
      },
      {
        skillId: 'computer-network',
        skillName: _t('Computer Network'),
        skillSearchUrl: '/courses?query=computer%20network',
      },
      {
        skillId: 'spring-boot',
        skillName: _t('Spring Boot'),
        skillSearchUrl: '/courses?query=spring%20boot',
      },
      {
        skillId: 'php',
        skillName: _t('PHP'),
        skillSearchUrl: '/courses?query=php',
      },
      {
        skillId: 'node-js',
        skillName: _t('Node.js'),
        skillSearchUrl: '/courses?query=node%20js',
      },
    ],
    'data-science': [
      {
        skillId: 'python',
        skillName: _t('Python'),
        skillSearchUrl: '/courses?query=python',
      },
      {
        skillId: 'sql',
        skillName: _t('SQL'),
        skillSearchUrl: '/courses?query=sql',
      },
      {
        skillId: 'statistics',
        skillName: _t('Statistics'),
        skillSearchUrl: '/courses?query=statistics',
      },
      {
        skillId: 'data-engineering',
        skillName: _t('Data Engineering'),
        skillSearchUrl: '/courses?query=data%20engineering',
      },
      {
        skillId: 'business-intelligence',
        skillName: _t('Business Intelligence'),
        skillSearchUrl: '/courses?query=business%20intelligence',
      },
      {
        skillId: 'database',
        skillName: _t('Database'),
        skillSearchUrl: '/courses?query=database',
      },
      {
        skillId: 'biostatistics',
        skillName: _t('Biostatistics'),
        skillSearchUrl: '/courses?query=biostatistics',
      },
      {
        skillId: 'apache-spark',
        skillName: _t('Apache Spark'),
        skillSearchUrl: '/courses?query=apache%20spark',
      },
      {
        skillId: 'r',
        skillName: _t('R Programming'),
        skillSearchUrl: '/courses?query=r',
      },
      {
        skillId: 'database-management',
        skillName: _t('Database Management'),
        skillSearchUrl: '/courses?query=database%20management',
      },
    ],
    'social-sciences': [
      {
        skillId: 'international-relations',
        skillName: _t('International Relations'),
        skillSearchUrl: '/courses?query=international%20relations',
      },
      {
        skillId: 'public-policy',
        skillName: _t('Public Policy'),
        skillSearchUrl: '/courses?query=public%20policy',
      },
      {
        skillId: 'political-science',
        skillName: _t('Political Science'),
        skillSearchUrl: '/courses?query=political%20science',
      },
      {
        skillId: 'social-work',
        skillName: _t('Social Work'),
        skillSearchUrl: '/courses?query=social%20work',
      },
      {
        skillId: 'sociology',
        skillName: _t('Sociology'),
        skillSearchUrl: '/courses?query=sociology',
      },
      {
        skillId: 'anthropology',
        skillName: _t('Anthropology'),
        skillSearchUrl: '/courses?query=anthropology',
      },
      {
        skillId: 'governance',
        skillName: _t('Governance'),
        skillSearchUrl: '/courses?query=governance',
      },
    ],
    'physical-science-and-engineering': [
      {
        skillId: 'civil-engineering',
        skillName: _t('Civil Engineering'),
        skillSearchUrl: '/courses?query=civil%20engineering',
      },
      {
        skillId: 'architecture',
        skillName: _t('Architecture'),
        skillSearchUrl: '/courses?query=architecture',
      },
      {
        skillId: 'sustainability',
        skillName: _t('Sustainability'),
        skillSearchUrl: '/courses?query=sustainability',
      },
      {
        skillId: 'astronomy',
        skillName: _t('Astronomy'),
        skillSearchUrl: '/courses?query=astronomy',
      },
      {
        skillId: 'electronics',
        skillName: _t('Electronics'),
        skillSearchUrl: '/courses?query=electronics',
      },
      {
        skillId: 'physics',
        skillName: _t('Physics'),
        skillSearchUrl: '/courses?query=physics',
      },
      {
        skillId: 'chemical-engineering',
        skillName: _t('Chemical Engineering'),
        skillSearchUrl: '/courses?query=chemical%20engineering',
      },
      {
        skillId: 'industrial-design',
        skillName: _t('Industrial Design'),
        skillSearchUrl: '/courses?query=industrial%20design',
      },
      {
        skillId: 'geology',
        skillName: _t('Geology'),
        skillSearchUrl: '/courses?query=geology',
      },
      {
        skillId: '3d-printing',
        skillName: _t('3D Printing'),
        skillSearchUrl: '/courses?query=3d%20printing',
      },
    ],
    'personal-development': [
      {
        skillId: 'critical-thinking',
        skillName: _t('Critical Thinking'),
        skillSearchUrl: '/courses?query=critical%20thinking',
      },
      {
        skillId: 'soft-skills',
        skillName: _t('Soft Skills'),
        skillSearchUrl: '/courses?query=soft%20skills',
      },
      {
        skillId: 'sustainability',
        skillName: _t('Sustainability'),
        skillSearchUrl: '/courses?query=sustainability',
      },
      {
        skillId: 'career',
        skillName: _t('Career'),
        skillSearchUrl: '/courses?query=career',
      },
      {
        skillId: 'intercultural-communication',
        skillName: _t('Intercultural Communication'),
        skillSearchUrl: '/courses?query=intercultural%20communication',
      },
      {
        skillId: 'stress-management',
        skillName: _t('Stress Management'),
        skillSearchUrl: '/courses?query=stress%20management',
      },
      {
        skillId: 'fitness',
        skillName: _t('Fitness'),
        skillSearchUrl: '/courses?query=fitness',
      },
      {
        skillId: 'professional-development',
        skillName: _t('Professional Development'),
        skillSearchUrl: '/courses?query=professional%20development',
      },
      {
        skillId: 'music',
        skillName: _t('Music'),
        skillSearchUrl: '/courses?query=music',
      },
      {
        skillId: 'meditation',
        skillName: _t('Meditation'),
        skillSearchUrl: '/courses?query=meditation',
      },
      {
        skillId: 'parenting',
        skillName: _t('Parenting'),
        skillSearchUrl: '/courses?query=parenting',
      },
    ],
    'math-and-logic': [
      {
        skillId: 'mathematics',
        skillName: _t('Mathematics'),
        skillSearchUrl: '/courses?query=mathematics',
      },
      {
        skillId: 'calculus',
        skillName: _t('Calculus'),
        skillSearchUrl: '/courses?query=calculus',
      },
      {
        skillId: 'linear-algebra',
        skillName: _t('Linear Algebra'),
        skillSearchUrl: '/courses?query=linear%20algebra',
      },
      {
        skillId: 'differential-equation',
        skillName: _t('Differential Equation'),
        skillSearchUrl: '/courses?query=differential%20equation',
      },
      {
        skillId: 'pre-calculus',
        skillName: _t('Precalculus'),
        skillSearchUrl: '/courses?query=pre%20calculus',
      },
    ],
    'life-sciences': [
      {
        skillId: 'medical',
        skillName: _t('Medicine'),
        skillSearchUrl: '/courses?query=medical',
      },
      {
        skillId: 'pharmaceutical',
        skillName: _t('Pharmaceuticals'),
        skillSearchUrl: '/courses?query=pharmaceutical',
      },
      {
        skillId: 'neuroscience',
        skillName: _t('Neuroscience'),
        skillSearchUrl: '/courses?query=neuroscience',
      },
      {
        skillId: 'radiology',
        skillName: _t('Radiology'),
        skillSearchUrl: '/courses?query=radiology',
      },
      {
        skillId: 'dental',
        skillName: _t('Dentistry'),
        skillSearchUrl: '/courses?query=dental',
      },
      {
        skillId: 'anatomy',
        skillName: _t('Anatomy'),
        skillSearchUrl: '/courses?query=anatomy',
      },
      {
        skillId: 'molecular-biology',
        skillName: _t('Molecular Biology'),
        skillSearchUrl: '/courses?query=molecular%20biology',
      },
      {
        skillId: 'pathology',
        skillName: _t('Pathology'),
        skillSearchUrl: '/courses?query=pathology',
      },
      {
        skillId: 'physiology',
        skillName: _t('Physiology'),
        skillSearchUrl: '/courses?query=physiology',
      },
      {
        skillId: 'oncology',
        skillName: _t('Oncology'),
        skillSearchUrl: '/courses?query=oncology',
      },
    ],
    'information-technology': [
      {
        skillId: 'information-security',
        skillName: _t('Information Security'),
        skillSearchUrl: '/courses?query=information%20security',
      },
      {
        skillId: 'microservices',
        skillName: _t('Microservices'),
        skillSearchUrl: '/courses?query=microservices',
      },
      {
        skillId: 'control-systems',
        skillName: _t('Control Systems'),
        skillSearchUrl: '/courses?query=control%20systems',
      },
      {
        skillId: 'cloud-security',
        skillName: _t('Cloud Security'),
        skillSearchUrl: '/courses?query=cloud%20security',
      },
      {
        skillId: 'enterprise-architecture',
        skillName: _t('Enterprise Architecture'),
        skillSearchUrl: '/courses?query=enterprise%20architecture',
      },
      {
        skillId: 'git',
        skillName: _t('GIT'),
        skillSearchUrl: '/courses?query=git',
      },
      {
        skillId: 'application-security',
        skillName: _t('Application Security'),
        skillSearchUrl: '/courses?query=application%20security',
      },
      {
        skillId: 'it-support',
        skillName: _t('IT Support'),
        skillSearchUrl: '/courses?query=it%20support',
      },
      {
        skillId: 'computer-network',
        skillName: _t('Computer Network'),
        skillSearchUrl: '/courses?query=computer%20network',
      },
      {
        skillId: 'cisco-networking',
        skillName: _t('Cisco Networking'),
        skillSearchUrl: '/courses?query=cisco%20networking',
      },
    ],
    'language-learning': [
      {
        skillId: 'Teaching English',
        skillName: _t('Teaching English'),
        skillSearchUrl: '/courses?query=teaching%20english',
      },
      {
        skillId: 'french-language',
        skillName: _t('French'),
        skillSearchUrl: '/courses?query=french%20language',
      },
      {
        skillId: 'spanish',
        skillName: _t('Spanish'),
        skillSearchUrl: '/courses?query=spanish',
      },
      {
        skillId: 'korean',
        skillName: _t('Korean'),
        skillSearchUrl: '/courses?query=korean',
      },
      {
        skillId: 'linguistics',
        skillName: _t('Linguistics'),
        skillSearchUrl: '/courses?query=linguistics',
      },
      {
        skillId: 'russian-language',
        skillName: _t('Russian'),
        skillSearchUrl: '/courses?query=russian%20language',
      },
      {
        skillId: 'chinese',
        skillName: _t('Chinese'),
        skillSearchUrl: '/courses?query=chinese',
      },
      {
        skillId: 'english-grammar',
        skillName: _t('English Grammar'),
        skillSearchUrl: '/courses?query=english%20grammar',
      },
    ],
  };
};

export default getDomainPopularTopicsData;
